/**
 * Pool Not Found View
 * Pure functional component that displays when pool is not available
 * Uses light levels system (P400 card on P500 background)
 */
export const CreatePositionPoolNotFoundView = () => {
  return (
    <div className="max-w-md rounded-lg border border-p300-light bg-p300 p-6">
      <h2 className="mb-2 text-xl font-bold text-t100">Pool Not Found</h2>
      <p className="text-t300">The pool is loading or could not be found. Please wait or check the pool address.</p>
    </div>
  )
}
